// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","additionalNotes":"_37EkH"};